var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 16,
    height: 16,
    rx: 8,
    transform: "rotate(-180 18 18)",
    fill: "#FDF4E5",
    stroke: "#FFF6E5",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.9589L12.0256 10.9589L12.0256 5L7.9744 5L7.9744 10.8578L6 10.8578L9.952 15L14 10.9589Z",
    fill: "#00CC99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnloadIcon);
export default __webpack_public_path__ + "static/media/unload_icon.54d4a7666a76b41105f914e281f81fa3.svg";
export { ForwardRef as ReactComponent };